import { Link } from 'gatsby';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import ReactMoment from 'react-moment';
import Menu from '../menu/menu.component';

import './privacy-policy.styles.scss';

type PrivacyPolicyProps = {
  content: string;
  lastModified: string;
};

const PrivacyPolicy: React.FC<PrivacyPolicyProps> = ({
  content,
  lastModified,
}) => {
  return (
    <div className="privacy-policy ptb-100">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-md-12">
            <div className="privacy-policy-content">
              <img
                src={require('../../../assets/photos/privacy-policy.jpg')}
                alt="privacy policy"
              />
              <p>
                <i>
                  This Privacy Policy was last updated on{' '}
                  <ReactMoment format="MMM Do YYYY">{lastModified}</ReactMoment>
                  .
                </i>
              </p>
              <ReactMarkdown source={content} allowDangerousHtml />
            </div>
          </div>

          <div className="col-lg-4 col-md-12">
            <Menu
              quickLinks={[
                { title: 'Who We Are', to: '/who-we-are' },
                { title: 'Contact', to: '/contact' },
                {
                  title: 'Privacy Policy',
                  to: '/privacy-policy',
                  active: true,
                },
                { title: 'Terms and Conditions', to: '/terms-and-conditions' },
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
